
import "./App.css";
import "./fonts.css";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import {Provider} from "react-redux";
import {ThemeProvider} from "./ThemeContext";
import {RouterProvider} from "react-router-dom";
import {store} from "./store/store";
import routes from "routes";
import Loader from "./components/Loader";
import ThemeModal from "./components/ThemeModal/ThemeModal";
import {
  initOutboundClickTracking,
  initPendingPurchaseFlush,
  initSpaVirtualPageview,
} from "./analytics";

function App() {
    useEffect(() => {
        initOutboundClickTracking();
        initSpaVirtualPageview();
        initPendingPurchaseFlush();
    }, []);

    return (
        <Provider store={store}>
            <ThemeProvider>
                <Loader>
                    {/*<CookieConsent />*/}
                    <ThemeModal/>
                    <RouterProvider router={routes}/>
                </Loader>
            </ThemeProvider>
        </Provider>
    );
}

export default App;